import React, { ReactNode } from "react";

type Props = {
  title: string;
  children: ReactNode;
};

const Tab: React.FC<Props> = ({ children }) => {
  return <div>{children}</div>;
};

export default Tab;
